module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/difference-between-vux-template-and-webpack-template-12.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/difference-between-vux-template-and-webpack-template.md
// module id = 589
// module chunks = 447